exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:50em){.card__content[data-v-168269b8]{grid-template-areas:\"slider slider\" \"aside main\"}}@media only screen and (min-width:64.063em){.card__content[data-v-168269b8]{grid-template-areas:\"aside slider\" \"aside main\"}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-168269b8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/parts/catalog/card/Card.vue
// module id = c0d09b7f01ccf450123a
// module chunks = 5